import { Grid } from '@mui/material';
import CounterWithTablewithoutGraph from './CounterWithTablewithoutGraph';

const CounterWithTablesWithoutGraphs = ({title, tableData, tableLabels, Analytics}) => {

  return (
    <>
      <Grid container spacing={3} marginTop={3}>
        <CounterWithTablewithoutGraph
          title={title}
          tableData={tableData}
          tableLabels={tableLabels}
          headerAnalyticsData = {Analytics}
        />
      </Grid>
    </>
  );
};
export default CounterWithTablesWithoutGraphs;
